﻿<span>
  <input type="radio" [checked]="gmtChecked" [disabled]="gmtDisabled" (change)="onChanged()"/>
  <span></span>
</span>
